import {
  landingPageFetchRequest,
  landingPageFetchRequestSuccess,
  landingPageFetchRequestFailure,
  landingPageAddRequest,
  landingPageAddRequestSuccess,
  landingPageAddRequestFailure,
} from './actions';
import { store, fetch, update } from '../../../utils/httpUtil';
import { getLocalStorage, setLocalStorage } from '../../../utils/storageUtil';
import {
  // REGISTRATION_STATUS,
  USER_ID,
  // USER_FULL_NAME,
  REQUEST_NUMBER,
} from '../../../constants/config';
import {
  basicInfoAddRequest,
  basicInfoAddRequestFailure,
  basicInfoAddRequestSuccess,
} from '../../kyc/basic/actions';

export const fetchLandingPage = () => {
  return (dispatch) => {
    dispatch(landingPageFetchRequest());
    return fetch(`client/v1/kyc/individual/${getLocalStorage(USER_ID)}/personal-info`)
      .then((response) => {
        if (response.data.message === 'SUCCESS') {
          dispatch(landingPageFetchRequestSuccess(response.data.data));
        } else {
          // TODO
        }
      })
      .catch((error) => dispatch(landingPageFetchRequestFailure(error.response.data)));
  };
};

export const updateLandingPage = (formData = {}) => {
  return (dispatch) => {
    dispatch(landingPageAddRequest());

    return store(`public/public-endpoints/api/customers/registrations`, formData)
      .then((response) => {
        if (response.data.message === 'SUCCESS') {
          dispatch(landingPageAddRequestSuccess(response.data.data));
          setLocalStorage(REQUEST_NUMBER, response.data.data.requestNumber);
          // return response;
          // dispatch(push({ pathname: `/dashboard` }));
        } else {
          // TODO
        }
      })
      .catch((error) => dispatch(landingPageAddRequestFailure(error.response.data)));
  };
};
export const getCustomerDetailFromDraft = (formData = {}) => {
  let headerValue =
    localStorage.getItem('OtpVerified') + ',' + localStorage.getItem('REGISTRATION_NUMBER'); // VAPT Url id issue
  return (dispatch) => {
    dispatch(basicInfoAddRequest());
    return update(
      `public/public-endpoints/api/customers/registrations/draft/details`,
      {
        registrationNumber: localStorage.getItem('REGISTRATION_NUMBER'),
        schemeName: JSON.parse(localStorage.getItem('schemeName')),
      },
      { headers: { 'Otp-Verified': headerValue } }
    )
      .then((response) => {
        if (response?.data?.message === 'SUCCESS') {
          dispatch(basicInfoAddRequestSuccess(response?.data?.data));
        } else {
          // TODO
        }
        return response;
      })
      .catch((error) => {
        dispatch(basicInfoAddRequestFailure(error.response.data));
        // history.push('/');
      });
  };
};

// export const getDraftDetailBasicInfo = (trackingNumber) => {
//   return (dispatch) => {
//     dispatch(basicInfoAddRequest());
//     return store('public/public-endpoints/api/customers/registrations/status', {
//       registrationNumber: trackingNumber,
//     })
//       .then((res) => {
//         return res;
//       })
//       .catch((ex) => {
//         throw ex;
//       });
//   };
// };
export const getSchemeInfo = (formData) => {
  return store('public/public-endpoints/api/customers/registrations/scheme', formData);
};

export const requestDraftDetailBasicInfo = (trackingNumber) => {
  return (dispatch) => {
    dispatch(basicInfoAddRequest());
    return store('public/public-endpoints/api/customers/registrations/modify/request', {
      requestNumber: trackingNumber,
    })
      .then((res) => {
        window.localStorage.setItem(REQUEST_NUMBER, res?.data?.data?.requestNumber);
        window.localStorage.setItem('statusRequest', trackingNumber);
      })
      .catch((ex) => {
        throw ex;
      });
  };
};
